<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Member add</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content *ngIf="!toShowAccounts">
    <div class="row g-2 justify-content-between phone-field">
        <mat-form-field appearance="outline" class="country-code col-12">
          <mat-label>Country Code</mat-label>
          <mat-select
          [(ngModel)]="selectedCountryCode"
          required
          (selectionChange)="onCountrySelected($event)"
        >
          <mat-select-trigger>
            {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                {{ "(" + selectedCountryCode.dial_code + ")" }}
          </mat-select-trigger>
          
          <mat-option>
            <ngx-mat-select-search
              noEntriesFoundLabel="no results found"
              name="countrysearch"
              placeholderLabel="Enter country name"
              [formControl]="searchString"
              (keyup)="onKey()"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let country of countryList" [value]="country">
            {{ country.flag }} {{ country.name }}
            {{ "(" + country.dial_code + ")" }}
          </mat-option>
        </mat-select>
        </mat-form-field>
        <mat-form-field class="mobile_form col-12" appearance="outline">
          <mat-label>Phone</mat-label>
          <input
          (keyup.enter)="onPost()"
            [(ngModel)]="newMemberData.customerPh"
            matInput
            type="tel"
            smNumericOnly
            minLength="3" 
            maxlength="17"
          />
          <mat-hint
            style="color: red; font-size: 13px"
            align="end"
            *ngIf="
              newMemberData.customerPh &&
              newMemberData.customerPh != '' &&
              newMemberData.customerPh.length < 3
            "
            >Enter a valid phone number.</mat-hint
          >
        </mat-form-field>
      </div>
  </mat-dialog-content>

  <mat-dialog-content *ngIf="toShowAccounts">
    <div class="row" *ngIf="accounts.length>0">
        <div class="col-sm-12" *ngFor="let item of accounts">
            <div class="fl_orders" (click)="selectAccount(item)">
                <div class="top_section_order">
                  <!-- Row start -->
                  <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon>
                </div>
                    <div class="flex_operx">
                        <div class="drd_section">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" >
                                    <img [src]="item.image_thumb_url" onerror="this.src='../../../../../assets/images/user-avatar.svg'">
                                </div>
                            </div>
                        </div>
                        <div class="drd_right_op">
                            <div class="order_dec">
          
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;
                                ">{{item.name}}</h3>
                                <p>{{selectedCountryCode.dial_code}} {{newMemberData.customerPh}}</p>
                             </div>

                        </div>
                       
                    </div>
                    <!-- row done -->
                </div>
            </div>
        </div>
        <div class="peod_checkopen">
        <p>We found a user in the network matching the phone number you added. Select and proceed with the person or change the phone number.</p>
      </div>   
      </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" *ngIf="!toShowAccounts">

    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        formChecker()
      "
      (click)="onPost()"
    >
      Confirm
    </button>
  </mat-dialog-actions>


  <mat-dialog-actions align="end" *ngIf="toShowAccounts">
    <button mat-button (click)="back()">Back</button>
    <button
      [disabled]="
      selectedAcc.length == 0

      "
      mat-flat-button
      color="accent"
      (click)="onSelectNext()"
    >
      Proceed
    </button>
  </mat-dialog-actions>
  